import { MixedTags } from '@yaireo/tagify/dist/react.tagify';

import DropdownItem from './dropdown_item';
import Tag from './tag';

import './styles.scss';

export const Tagify = MixedTags;

export const settings = {
  duplicates: true,
  enforceWhitelist: true,
  onChangeAfterBlur: false,

  dropdown: {
    classname: 'deal-tagged-body-input-tag-dropdown shadow-lg overflow-visible',
    highlightFirst: true,
    includeSelectedTags: true,
    maxItems: 100,
    searchKeys: ['email', 'name', 'value'],

    // Min number of characters after an @ before showing dropdown, zero shows immediately
    enabled: 0,

    // Sorting items by type is required for group header rendering to work correctly
    // Unknown types should be at the end so they are not the default selection
    sortby(items) {
      return items.sort((a, b) => {
        if (a.type === b.type) {
          return 0;
        } else if (!a.type) {
          return 1;
        } else if (!b.type) {
          return -1;
        } else {
          return a.type < b.type ? 1 : -1;
        }
      });
    },
  },

  templates: {
    dropdownItem: DropdownItem,
    dropdownFooter: () => '',
    tag: Tag,
  },
};
